import { ApiConnector } from '@/api/api.connector';

import type {
  IBlackListItem,
  ICreateBlackItem,
  IGetBlackListParams,
  IGetBlackListResponse
} from '../pages/BlackList/types/black-list.types';

class BlackListApi extends ApiConnector {
  getBlackList(params: IGetBlackListParams): Promise<IGetBlackListResponse> {
    return this.call({ path: 'admin/black_list', params });
  }

  getBlackItem(id: string): Promise<IBlackListItem> {
    return this.call({ path: `admin/black_list/${id}` });
  }

  createBlackItem(data: ICreateBlackItem) {
    return this.call({
      path: 'admin/black_list',
      method: 'post',
      body: data
    });
  }

  updateBlackItem(id: string, data: Partial<ICreateBlackItem>) {
    return this.call({
      path: `admin/black_list`,
      method: 'patch',
      body: { ...data, uuid: id }
    });
  }

  parseBlackListFromXML(body: { xml: string }) {
    return this.call({
      path: 'admin/black_list/parse-xml',
      method: 'post',
      body
    });
  }
}

export const blackListApi = new BlackListApi();
